import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { Link } from "gatsby"

import { Image } from "./Image"
import { StyledButton } from "../Styled/Button"

const Wrapper = styled.div<WrapperProps>`
  ${tw`relative w-full h-full`}
  ${({ rounded }) => (rounded ? tw`rounded-full overflow-hidden` : "")}
`
const Container = styled.div`
  ${tw`absolute inset-0 flex pb-2-4 md:pb-4 items-end justify-center z-10 opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all transform duration-slow`}
`
const Button = styled(StyledButton)<ButtonProps>`
  ${tw`flex z-10 bg-transparent items-center justify-center`}
  ${({ layout }) => (layout === "secondary" ? tw`bg-lightest` : "")}
`

const ImageCTA = ({
  image,
  location = null,
  buttonText = null,
  buttonLink = null,
  alt = null,
  onClick = null,
  onClickImage = null,
  imageLink = null,
  style = null,
  ratio = null,
  objectFit = null,
  textSize = null,
  rounded = null,
  maxWidth = null,
  loading = null,
}) => {
  return (
    <Wrapper className={`group`} rounded={rounded}>
      {buttonLink ? (
        <Container>
          {buttonLink && buttonText ? (
            <Button
              as={buttonLink ? Link : null}
              to={buttonLink}
              hover={style === "secondary" ? "true" : "false"}
              layout={style}
              textsize={textSize}
              background={`transparent`}
              colour={`transparent`}
              aria-label={buttonText}
            >
              {buttonText}
            </Button>
          ) : buttonText && onClick ? (
            <Button onClick={onClick} layout={style}>
              {buttonText}
            </Button>
          ) : null}
        </Container>
      ) : null}

      <Image
        alt={alt}
        location={location}
        image={image}
        ratio={ratio || `11/12`}
        onClick={onClickImage}
        imageLink={imageLink}
        objectFit={objectFit}
        maxWidth={maxWidth}
        loading={loading}
      />
    </Wrapper>
  )
}

export default ImageCTA

type WrapperProps = {
  rounded: boolean
}

type ButtonProps = {
  layout: "secondary" | undefined
}
